"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UplinkPayloadAttributeMetaTypes = void 0;
/**
 * @enum UplinkPayloadAttributeMetaTypes
 * classifies attributes in payload instance by the intended use / meaning type. Used where system needs to route parts of uplink differently
 */
var UplinkPayloadAttributeMetaTypes;
(function (UplinkPayloadAttributeMetaTypes) {
    UplinkPayloadAttributeMetaTypes["DEVICE_CONFIG"] = "DEVICE_CONFIG";
    UplinkPayloadAttributeMetaTypes["DEVICE_DIAGNOSTIC"] = "DEVICE_DIAGNOSTIC";
    UplinkPayloadAttributeMetaTypes["DEVICE_ERROR"] = "DEVICE_ERROR";
    UplinkPayloadAttributeMetaTypes["DEVICE_MEASUREMENT"] = "DEVICE_MEASUREMENT";
    UplinkPayloadAttributeMetaTypes["DEVICE_META_DATA"] = "DEVICE_META_DATA";
    UplinkPayloadAttributeMetaTypes["DEVICE_STATUS"] = "DEVICE_STATUS";
})(UplinkPayloadAttributeMetaTypes || (exports.UplinkPayloadAttributeMetaTypes = UplinkPayloadAttributeMetaTypes = {}));
